module.exports = __webpack_public_path__ + "static/media/h0z1d3r.79887e60.svg";